"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedIcuDateFormatPattern = exports.localizedIcuDateFormatPatterns = exports.DEFAULT_LOCALE = exports.getLocalizedDateFormat = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var moment_1 = tslib_1.__importDefault(require("moment"));
var util_1 = require("@gooddata/util");
exports.getLocalizedDateFormat = function (locale) {
    var _a;
    var localizedMoment = moment_1.default().locale(util_1.translationUtils.sanitizeLocaleForMoment(locale));
    var localeData = (localizedMoment === null || localizedMoment === void 0 ? void 0 : localizedMoment.localeData) && localizedMoment.localeData();
    return (_a = localeData === null || localeData === void 0 ? void 0 : localeData._longDateFormat) === null || _a === void 0 ? void 0 : _a.L;
};
exports.DEFAULT_LOCALE = "en-US";
/**
 * Localized date format patterns for DAY granularity according to ICU. In case backend has the ability to define the patterns,these should
 * match with the backend definitions.
 *
 * See https://date-fns.org/docs/format and https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 */
exports.localizedIcuDateFormatPatterns = {
    "en-US": "M/d/y",
    "en-GB": "dd/MM/y",
    "cs-CZ": "d. M. y",
    "de-DE": "d.M.y",
    "es-ES": "d/M/y",
    "fr-FR": "dd/MM/y",
    "ja-JP": "y/M/d",
    "nl-NL": "d-M-y",
    "pt-BR": "dd/MM/y",
    "pt-PT": "dd/MM/y",
    "zh-Hans": "y/M/d",
    "ru-RU": "dd.MM.y",
};
/**
 * Returns localized date format pattern for DAY granularity according to ICU. Unsupported locales default to en-US.
 *
 * See https://date-fns.org/docs/format and https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * @internal
 */
exports.getLocalizedIcuDateFormatPattern = function (locale) { var _a; return (_a = exports.localizedIcuDateFormatPatterns[locale]) !== null && _a !== void 0 ? _a : exports.localizedIcuDateFormatPatterns[exports.DEFAULT_LOCALE]; };
//# sourceMappingURL=FormattingUtils.js.map